'use client'
import {
  context_default
} from "./chunk-4HCJHTK4.mjs";

// src/context/config/useConfig.ts
import { useContext } from "react";
var useConfig = () => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
var useConfig_default = useConfig;

export {
  useConfig,
  useConfig_default
};
//# sourceMappingURL=chunk-ZSKGVFZ4.mjs.map